import PropTypes from 'prop-types'
import React from 'react'
import { useParams } from 'react-router-dom'
import Container from '../../atoms/Container'
import CitizenHeader from '../question_fields/CitizenHeader'
import TrackingGeneralInfo from './TrackingGeneralInfo'
import { getStateByCode } from '../../../configs/answerConfig'
import TrackingHistory from './TrackingHistory'

const TrackingInfoAnswer = ({ answer }) => {
  const { answerHashId } = useParams()

  const { answer_lines: answerLines, form, confirmed_at: confirmedAt } = answer
  const statusHistory = [{ label: 'NUEVO', date: confirmedAt }].concat(answer.status_history)
  const generalDetail = [
    { label: 'Trámite:', content: form.name },
    { label: 'Entidad:', content: form.institution },
    { label: 'Nombre del solicitante:', content: answer.applicant_name },
    { label: 'Fecha de envío:', content: confirmedAt }
  ].filter(detail => detail.content)

  const stepValues = statusHistory.map(step => {
    const stateByCode = getStateByCode(step.label)
    return {
      date: step.date,
      name: stateByCode.citizenStepName || stateByCode.citizenName
    }
  })

  return (
    <>
      <CitizenHeader name={form.name} institution={form.institution} />
      <Container className="py-8">
        <main>
          <h1 className="font-bold md:text-4xl text-3xl mb-8 mx-6 md:mx-0">Seguimiento de tu solicitud </h1>
          <div className="flex flex-col md:flex-row gap-6 mb-6">
            <TrackingGeneralInfo
              code={answerHashId}
              generalDetail={generalDetail}
              stepValues={stepValues}
              isEnded={answer.is_ended}
            />
            <div className="w-full md:w-7/12 lg:w-9/12">
              <TrackingHistory
                confirmedAt={confirmedAt}
                answerLines={answerLines}
                statusHistory={answer.status_history}
              />
            </div>
          </div>
        </main>
      </Container>
    </>
  )
}

export default TrackingInfoAnswer

TrackingInfoAnswer.propTypes = {
  answer: PropTypes.object.isRequired
}
